import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PgLoadingComponent } from './pg-loading/pg-loading.component';
import { PgCarouselComponentSlide, PgCarouselComponent } from './pg-carousel/pg-carousel.component';
import { SafePipe } from './safe.pipe';
import { StripHTMLPipe } from './strip-html.pipe';
import { TranslatorDirective, FormatterDirective } from './localization.directive';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PgFilePreviewComponent } from './pg-file-preview/pg-file-preview.component';
import { ExternalLinksDirective } from './external-links.directive';
import { PgConfirmActionComponent } from './pg-confirm-action/pg-confirm-action.component';
import { LocTranslatePipe, LocFormatPipe, LocIconPipe } from './localization.pipe';
import { PgAnimationsDirective } from './pg-animations.directive';
import { PgImageCropModalComponent } from './pg-image-crop-modal/pg-image-crop-modal.component';
import { ImageCropperModule } from 'ngx-img-cropper';
import { AudioMixerService } from '../services/audio-mixer.service';
import { PgUploadButtonComponent } from './pg-upload-button/pg-upload-button.component';
import { PgQrcodeComponent } from './pg-qrcode/pg-qrcode.component';
import { PgGrowNumberDirective } from './pg-grow-number.directive';
import { QrLinksDirective } from './qr-links.directive';
import { QrLinksModalComponent } from './qr-links-modal/qr-links-modal.component';
import { PgGraphComponent } from './pg-graph/pg-graph.component';
import { PgCookieConsentComponent } from './pg-cookie-consent/pg-cookie-consent.component';
import { PgCollapsibleContainerDirective } from './pg-collapsible-container.directive';
import { PgNavTreeComponent } from './pg-nav-tree/pg-nav-tree.component';
import { PgShowcaseComponent } from './pg-showcase/pg-showcase.component';
import { PgMaintenanceComponent } from './pg-maintenance/pg-maintenance.component';
import { PgLanguageSelectorComponent } from './pg-language-selector/pg-language-selector.component';
import { PgNotificationComponent } from './pg-notification/pg-notification.component';
import { PgImageAutosizeComponent } from './pg-image-autosize/pg-image-autosize.component';
import { PgStripeConnectComponent } from './pg-stripe-connect/pg-stripe-connect.component';
import { PgViewMoreComponent } from './pg-view-more/pg-view-more.component';
import { PgCopyClipboardComponent } from './pg-copy-clipboard/pg-copy-clipboard.component';
import { PgModalComponent } from './pg-modal/pg-modal.component';
import { PgRealmCardComponent } from './pg-realm-card/pg-realm-card.component';
import { PgCustomerCareBookingComponent } from './pg-customer-care-booking/pg-customer-care-booking.component';
import { PgUserComponent } from './pg-user/pg-user.component';
import { CustomFnPipe } from './custom-fn.pipe';
import { PgQrcodeScannerComponent } from './pg-qrcode-scanner/pg-qrcode-scanner.component';
import { PgMapLinkComponent } from './pg-map-link/pg-map-link.component';
import { PwaInstallGuideModalComponent } from './pwa-install-guide-modal/pwa-install-guide-modal.component';
import { VisitCardImageComponent } from './visit-card-image/visit-card-image.component';
import { PgShareComponent } from './pg-share/pg-share.component';
import { PgTagImageComponent } from './pg-tag-image/pg-tag-image.component';
import { PgUserStatusComponent } from './pg-user-status/pg-user-status.component';

@NgModule({
    declarations: [
        PgLoadingComponent,
        PgCarouselComponent,
        PgCarouselComponentSlide,
        PgGrowNumberDirective,
        TranslatorDirective,
        FormatterDirective,
        SafePipe,
        StripHTMLPipe,
        LocTranslatePipe,
        LocFormatPipe,
        PgFilePreviewComponent,
        ExternalLinksDirective,
        PgConfirmActionComponent,
        PgAnimationsDirective,
        PgImageCropModalComponent,
        PgUploadButtonComponent,
        PgQrcodeComponent,
        QrLinksDirective,
        QrLinksModalComponent,
        PgGraphComponent,
        PgCookieConsentComponent,
        PgCollapsibleContainerDirective,
        PgNavTreeComponent,
        PgShowcaseComponent,
        PgMaintenanceComponent,
        PgLanguageSelectorComponent,
        PgNotificationComponent,
        PgImageAutosizeComponent,
        PgStripeConnectComponent,
        LocIconPipe,
        PgViewMoreComponent,
        PgCopyClipboardComponent,
        PgModalComponent,
        PgRealmCardComponent,
        PgCustomerCareBookingComponent,
        PgUserComponent,
        PgQrcodeScannerComponent, 
        CustomFnPipe,
        PgMapLinkComponent,
        PwaInstallGuideModalComponent,
        VisitCardImageComponent,
        PgShareComponent,
        PgTagImageComponent,
        PgUserStatusComponent
    ],
    imports: [
        CommonModule,
        NgbModule,
        ImageCropperModule
    ],
    exports: [
        PgLoadingComponent,
        PgCarouselComponent,
        PgCarouselComponentSlide,
        PgGrowNumberDirective,
        TranslatorDirective,
        FormatterDirective,
        SafePipe,
        StripHTMLPipe,
        LocTranslatePipe,
        LocFormatPipe,
        PgFilePreviewComponent,
        ExternalLinksDirective,
        PgConfirmActionComponent,
        PgAnimationsDirective,
        PgImageCropModalComponent,
        PgUploadButtonComponent,
        PgQrcodeComponent,
        QrLinksDirective,
        PgGraphComponent,
        PgCookieConsentComponent,
        PgCollapsibleContainerDirective,
        PgNavTreeComponent,
        PgShowcaseComponent,
        PgMaintenanceComponent,
        PgLanguageSelectorComponent,
        PgNotificationComponent,
        PgImageAutosizeComponent,
        PgStripeConnectComponent,
        LocIconPipe,
        PgViewMoreComponent,
        PgCopyClipboardComponent,
        PgModalComponent,
        PgRealmCardComponent,
        PgCustomerCareBookingComponent,
        PgUserComponent,
        PgQrcodeScannerComponent,
        CustomFnPipe,
        PgMapLinkComponent,
        VisitCardImageComponent,
        PgShareComponent,
        PgTagImageComponent,
        PgUserStatusComponent
    ],
    providers: [provideAppInitializer(() => {
        const initializerFn = ((audioMixerService:AudioMixerService): Function => {
            return () => {
                return new Promise((resolve, reject) => {
                    audioMixerService.init();
                    resolve(null);
                })
            };
        })(inject(AudioMixerService));
        return initializerFn();
      })]
})
export class PgUiElementsModule { }
